module.exports = __webpack_public_path__ + "img/android-consumer.8b3d0904.png";